import { Controller } from '@hotwired/stimulus'

// PDT-RNK-1967. Ejecuta reCAPTCHA v3 invisible justo antes del submit del
// form de recuperación. El usuario no ve nada (no hay checkbox ni desafío),
// el script de Google calcula un score basado en el comportamiento del
// navegador y lo manda como token oculto al backend.
//
// Si el script de Google no llega a cargar (red bloqueada, adblocker), el
// hidden field queda vacío y el backend trata la petición como "reCAPTCHA
// missing" → renderiza la vista genérica sin disparar lookup en BD. Misma
// UX visible que el caso match, así no se delata el bloqueo al usuario.
export default class extends Controller {
  static targets = ['form', 'recaptchaToken']
  static values = { siteKey: String, action: String }

  submit(event) {
    if (!this.siteKeyValue || typeof grecaptcha === 'undefined') {
      return
    }

    event.preventDefault()

    grecaptcha.ready(() => {
      grecaptcha
        .execute(this.siteKeyValue, { action: this.actionValue })
        .then((token) => {
          this.recaptchaTokenTarget.value = token
          this.formTarget.submit()
        })
        .catch(() => {
          this.formTarget.submit()
        })
    })
  }
}
